import api from 'Application/api/api';

const getProjectTypes = (signal, query) =>
	api.get('/project-types/get-pageable', {
		params: {
			name: query,
		},
		signal,
	});

export default getProjectTypes;
